/** Customer-facing book text. Strip internal book labels before display or print. */
export function hideBookHints(text) {
  if (text == null) return '';
  return String(text)
    .replace(/\s*\(\s*from\s+vps\s*b\s*\)/gi, '')
    .replace(/\bfrom\s+vps\s*b\b/gi, '')
    .replace(/\bvps\s*b\b/gi, '')
    .replace(/interest\s*\.?\s*14/gi, 'Interest')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+([—-])/g, ' $1')
    .trim();
}
